import { render, staticRenderFns } from "./ChargeItem.vue?vue&type=template&id=461e80b4&scoped=true&lang=pug"
import script from "./ChargeItem.vue?vue&type=script&lang=js"
export * from "./ChargeItem.vue?vue&type=script&lang=js"
import style0 from "./ChargeItem.vue?vue&type=style&index=0&id=461e80b4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461e80b4",
  null
  
)

export default component.exports